import React from 'react';
import { Carousel, Button, Modal } from 'react-bootstrap';
import HTML2React from 'html2react';
import { Animated } from 'react-animated-css';
import DATA from './projectsData';

class Projects extends React.Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getButtons = this.getButtons.bind(this);
    this.filterProjects = this.filterProjects.bind(this);
    this.state = {
      show: false,
      projects: DATA.filter(function (data) {
        if (
          (data.client === 'A Major Crypto Start-Up' &&
            data.type[0] === 'Design and Architecture') ||
          (data.client === 'A Major Crypto Start-Up' &&
            data.type[0] === 'Devops')
        ) {
          return false;
        }
        return true;
      }).map(function (data) {
        return data;
      }),
      selectedProject: {
        type: '',
        name: '',
        location: '',
        description: '',
        images: [],
      },
      filterButtons: [
        'All',
        'Networking',
        'BFSI',
        'Health Care',
        'Transport & Logistics',
        'Travel & Leisure',
        'Airlines',
        'B2B & E-Commerce',
        'Innovation',
        'Entertainment',
        'Hiring/L&D',
        'Engineering',
        'Others',
      ],
      category: 'Industries',
      selectedButton: 'All',
      click: false,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(project) {
    this.setState({ show: true, selectedProject: project });
  }

  setFilter(filter) {
    this.setState({ selectedButton: filter });
  }
  isActive(value) {
    return value === this.state.selectedButton ? 'active' : '';
  }

  filterProjects(button) {
    this.setState({ projects: {} });
    let filterProjects = [];

    if (button !== 'All') {
      this.setState({ click: true });
      filterProjects = DATA.filter((data) => {
        if (data.type.indexOf(button) !== -1) {
          return data;
        }
      });
    } else {
      this.setState({ click: false });

      filterProjects = DATA.filter(function (data) {
        if (
          (data.client === 'A Major Crypto Start-Up' &&
            data.type[0] === 'Design and Architecture') ||
          (data.client === 'A Major Crypto Start-Up' &&
            data.type[0] === 'Devops')
        ) {
          return false;
        }
        return true;
      }).map(function (data) {
        return data;
      });
    }
    if (filterProjects.length < 8) {
      for (let x = filterProjects.length; x < 8; x++) {
        filterProjects[x] = {};
      }
    }
    this.setState({ projects: filterProjects });
  }

  get splitClientsData() {
    const projects = [];
    let items;
    let start = 0;
    let i = 1;
    for (i = 1; i <= this.state.projects.length / 8; i++) {
      items = this.state.projects.slice(start, 8 * i).map((project, index) =>
        project.name !== undefined ? (
          <div
            key={index}
            className='col-xs-12 col-sm-6 col-md-3 col-lg-3'
            onClick={() => this.handleShow(project)}
          >
            <div className='image-box'>
              <div className='project-image-border overlay-container'>
                <img src={project.images[0]} alt='' />{' '}
                <a className='overlay'>
                  {' '}
                  <span>{project.type[0]}</span>
                </a>
              </div>
              <a className='prjBtn btn-default btn-block'>
                {HTML2React(project.name)}
              </a>
            </div>
          </div>
        ) : (
          <div />
        )
      );
      start = 8 * i;
      projects[i] = items;
    }
    if (this.state.projects.length > start) {
      items = this.state.projects
        .slice(start, this.state.projects.length)
        .map((project, index) =>
          project.name !== undefined ? (
            <div
              key={index}
              className='col-xs-12 col-sm-6 col-md-3 col-lg-3'
              onClick={() => this.handleShow(project)}
            >
              <div className='image-box'>
                <div className='project-image-border overlay-container'>
                  <img src={project.images[0]} alt='' />{' '}
                  <a className='overlay'>
                    {' '}
                    <span>{project.type}</span>
                  </a>
                </div>
                <a className='prjBtn btn-default btn-block'>
                  {HTML2React(project.name)}
                </a>
              </div>
            </div>
          ) : (
            <div />
          )
        );
      projects[i] = items;
    }
    return projects;
  }

  get renderItem() {
    return (
      <Carousel
        id={this.state.selectedButton}
        indicators={this.state.projects.length > 8}
        controls={this.state.projects.length > 8}
        style={{ height: '100%', width: '100%' }}
        interval={4000}
      >
        {this.splitClientsData.map((item, index) => (
          <Carousel.Item
            key={index + this.state.selectedButton}
            active={index === 1}
          >
            {item}
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }

  getButtons(id) {
    switch (id) {
      case 0:
        this.setState({
          filterButtons: [
            'All',
            'Design and Architecture',
            'Web Application',
            'Quality Assurance',
            'Mobile Application',
            'Devops',
            'V-CTO',
            'Odoo ERP Integration',
          ],
          category: 'Work Type',
          projects: DATA,
          selectedButton: 'Design and Architecture',
        });
        this.filterProjects('Design and Architecture');
        break;
      case 1:
        this.setState({
          filterButtons: [
            'All',
            'Networking',
            'BFSI',
            'Health Care',
            'Transport & Logistics',
            'Travel & Leisure',
            'Airlines',
            'B2B & E-Commerce',
            'Innovation',
            'Entertainment',
            'Hiring/L&D',
            'Engineering',
            'Others',
          ],
          category: 'Industries',
          projects: DATA,
          selectedButton: 'Networking',
        });
        this.filterProjects('Networking');
        break;
      case 2:
        this.setState({
          filterButtons: [
            'All',
            'USA',
            'India',
            'Europe',
            'Japan',
            'Australia',
          ],
          category: 'Geography',
          projects: DATA,
          selectedButton: 'USA',
        });
        this.filterProjects('USA');
        break;
      case 3:
        this.setState({
          filterButtons: [
            'All',
            'Java',
            'Flutter',
            'React-JS / Native',
            'Node.JS',
            'Ruby',
            'Python',
            'PHP',
            'HTML / Bootstrap',
            'AI / ML',
          ],
          category: 'Technology',
          projects: DATA,
          selectedButton: 'Java',
        });
        this.filterProjects('Java');
        break;
      default:
        this.setState({
          filterButtons: [
            'All',
            'Design and Architecture',
            'Web Application',
            'Quality Assurance',
            'Mobile Application',
            'V-CTO',
            'Odoo ERP Integration',
          ],
          category: 'Work Type',
          projects: DATA,
          selectedButton: 'All',
        });
        this.filterProjects('All');
    }
  }

  render() {
    return (
      <div
        id='projects'
        className='section clearfix'
        data-animation-effect='In'
      >
        <h1 className='title text-center' style={{ marginTop: '4.5%' }}>
          Projects
        </h1>
        <div className='col-lg-1' />
        <div className='tab-content'>
          <div className='nav-pills col-md-2 col-lg-2'>
            <a
              className='btn btn-zzz category-button dropdown-toggle '
              data-toggle='dropdown'
              href='#'
            >
              {this.state.category} <span className='caret' />
            </a>
            <ul className='dropdown-menu'>
              <li onClick={() => this.getButtons(1)}>
                <a>Industries</a>
              </li>
              <li onClick={() => this.getButtons(3)}>
                <a>Technology</a>
              </li>
              <li onClick={() => this.getButtons(0)}>
                <a className='bounce'>Work Type</a>
              </li>
              <li onClick={() => this.getButtons(2)}>
                <a>Geography</a>
              </li>
            </ul>
          </div>
          <div className='tab-pane  active in col-md-10 col-lg-6'>
            <div className='filters text-center '>
              <ul className='nav nav-pills'>
                {this.state.filterButtons.map((button, index) => (
                  <li
                    className={this.isActive(button)}
                    id={index}
                    key={index}
                    onClick={this.setFilter.bind(this, button)}
                  >
                    <a
                      className='prjBtn '
                      onClick={() => this.filterProjects(button)}
                    >
                      {button}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className='scrl'>
            <div className='container-fluidic'>
              <div className='separator' />
              <div className='row ' data-animation-effect='In'>
                <div className='col-md-12 col-lg-12'>
                  <div className='isotope-container center row '>
                    <div id='wbitems' className='da-slider isotope-item wb'>
                      <div className='da-slide'>
                        <Animated
                          animationIn='fadeInRight'
                          animationOut='fadeOut'
                          isVisible
                        >
                          {this.state.click && this.state.projects.length < 9
                            ? this.state.projects.map((project, index) =>
                                project.name !== undefined ? (
                                  <div
                                    key={index}
                                    className='col-xs-12 col-sm-6 col-md-3 col-lg-3'
                                    onClick={() => this.handleShow(project)}
                                  >
                                    <div className='image-box'>
                                      <div className='project-image-border overlay-container'>
                                        <img src={project.images[0]} alt='' />{' '}
                                        <a className='overlay'>
                                          {' '}
                                          <span>{project.type[0]}</span>
                                        </a>
                                      </div>
                                      <a className='prjBtn btn-default btn-block'>
                                        {HTML2React(project.name)}
                                      </a>
                                    </div>
                                  </div>
                                ) : null
                              )
                            : this.renderItem}
                        </Animated>
                        <Modal
                          id='modalPopup'
                          show={this.state.show}
                          onHide={this.handleClose}
                          bsSize='large'
                          aria-labelledby='contained-modal-title-lg'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title id='contained-modal-title-lg'>
                              {this.state.selectedProject.client} -{' '}
                              {this.state.selectedProject.location}{' '}
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className='row'>
                              <div className='col-md-6 col-lg-6'>
                                <p>
                                  <ul>
                                    {HTML2React(
                                      this.state.selectedProject.description
                                    )}
                                  </ul>
                                </p>
                              </div>
                              <div className='col-md-6 col-sm-12 col-xs-12 col-lg-6'>
                                <Carousel
                                  id='projectSlider'
                                  style={{ height: '100%', width: '100%' }}
                                  controls={
                                    this.state.selectedProject.images.length > 2
                                  }
                                  indicators={
                                    this.state.selectedProject.images.length > 2
                                  }
                                  interval={2000}
                                >
                                  {this.state.selectedProject.images
                                    .slice(
                                      1,
                                      this.state.selectedProject.images.length
                                    )
                                    .map((image, index) => (
                                      <Carousel.Item key={index}>
                                        <center>
                                          <img
                                            src={image}
                                            alt={image}
                                            id='projectImages'
                                          />
                                        </center>
                                      </Carousel.Item>
                                    ))}
                                </Carousel>
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button onClick={this.handleClose}>Close</Button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/projects/index.js